import Vue from 'vue'
import Router from 'vue-router'
import Cookies from "js-cookie"
import Login from '@/views/Login'
import NotFound from '@/views/Error/404'
import Home from '@/views/Home'
import Intro from '@/views/Intro/Intro'
import perCenter from '@/views/Intro/PerCenter'
import Generator from '@/views/Generator/Generator'
import api from '@/http/api'
import store from '@/store'

import { getIFramePath, getIFrameUrl } from '@/utils/iframe'
const Index = ()=>import("@/views/Home/Home")

Vue.use(Router)

// 防止路由冗余加载
// const originalPush = Router.prototype.push

// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }

const router = new Router({
  routes: [
    {
      path: '/',
      name: '首页',
      component: Home,
      children: [
        {
          path: '/perCenter',
          name: '个人中心',
          component: perCenter,
          meta: {
            icon: 'fa fa-home fa-lg',
            index: 1
          }
        },
        {
          path: '/addnotice',
          name: '新增公告',
          component:()=>import("@/views/Commadmin/Notices/addvote"),
          meta: {
            icon: 'fa fa-home fa-lg',
            index: 1
          }
        },
        {
          path: '/addSafe',
          name: '新增安全宣传',
          component:()=>import("@/views/Commadmin/Safe/addvote"),
          meta: {
            icon: 'fa fa-home fa-lg',
            index: 1
          }
        },
        {
          path: '/addOnlineslist',
          name: '新增自动回复',
          component:()=>import("@/views/Commadmin/Onlineslist/addvote"),
          meta: {
            icon: 'fa fa-home fa-lg',
            index: 1
          }
        },
        {
          path: '/addEmergency',
          name: '新增社区应急',
          component:()=>import("@/views/Commadmin/Emergency/addvote"),
          meta: {
            icon: 'fa fa-home fa-lg',
            index: 1
          }
        },
        {
          path: '/addPolicy',
          name: '新增政策宣传',
          component:()=>import("@/views/Commadmin/Policy/addvote"),
          meta: {
            icon: 'fa fa-home fa-lg',
            index: 1
          }
        },
        {
          path: '/addPartyNews',
          name: '新增党建要闻',
          component:()=>import("@/views/Party/ImportNews/addvote"),
          meta: {
            icon: 'fa fa-home fa-lg',
            index: 1
          }
        },
        {
          path: '/addRoam',
          name: '新增党组织流转',
          component:()=>import("@/views/Commadmin/Roam/addvote"),
          meta: {
            icon: 'fa fa-home fa-lg',
            index: 1
          }
        },
        {
          path: '/addEducation',
          name: '新增教育宣传',
          component:()=>import("@/views/Commadmin/Education/add"),
          meta: {
            icon: 'fa fa-home fa-lg',
            index: 1
          }
        },

        {
          path: '/addActivity',
          name: '新增活动管理',
          component:()=>import("@/views/Commadmin/Activity/addvote"),
          meta: {
            icon: 'fa fa-home fa-lg',
            index: 1
          }
        },
        {
          path: '/addWork',
          name: '新增工作管理',
          component:()=>import("@/views/Commadmin/Work/addvote"),
          meta: {
            icon: 'fa fa-home fa-lg',
            index: 1
          }
        },
        {
          path: '/addGarbage',
          name: '新增垃圾分类宣传',
          component:()=>import("@/views/Commadmin/Garbage/addvote"),
          meta: {
            icon: 'fa fa-home fa-lg',
            index: 1
          }
        },
        {
          path: '/addCareTasks',
          name: '新增关怀任务',
          component:()=>import("@/views/Commadmin/CareTasks/addvote"),
          meta: {
            icon: 'fa fa-home fa-lg',
            index: 1
          }
        },
        {
          path: '/addVenuebooking',
          name: '新增场地预约',
          component:()=>import("@/views/Commadmin/Venuebooking/addvote"),
          meta: {
            icon: 'fa fa-home fa-lg',
            index: 1
          }
        },
        {
          path: '/addfood',
          name: '新增厨房配送',
          component:()=>import("@/views/Commadmin/Food/addvote"),
          meta: {
            icon: 'fa fa-home fa-lg',
            index: 1
          }
        },
        {
          path: '/aged/person',
          name: '养老人员',
          component:()=>import("@/views/Aged/Person/index"),
          meta: {
            icon: 'iconfont icon-shenpi',
            index: 1
          }
        },
      ]
    },
    {
      path: '/index',
      name: '数据总览',
      component: Intro,
    },
    {
      path: '/login',
      name: '登录',
      component: Login
    },
    {
      path: '/404',
      name: 'notFound',
      component: NotFound
    },
    // {
    //   path: '/addnotice',
    //   name: 'addnotice',
    //   component:()=>import("@/views/Commadmin/Notices/addvote")
    // },

  ]
})

router.beforeEach((to, from, next) => {
  // 登录界面登录成功之后，会把用户信息保存在会话
  // 存在时间为会话生命周期，页面关闭即失效。
  let token = sessionStorage.getItem('token')
  // var token=sessionStorage.getItem('token')
  let userName = sessionStorage.getItem('user')
  if (to.path === '/login') {
    // 如果是访问登录界面，如果用户会话信息存在，代表已登录过，跳转到主页
    if(token) {
      next({ path: '/' })
    } else {
      next()
    }
  } else {
    if (!token) {
      // 如果访问非登录界面，且户会话信息不存在，代表未登录，则跳转到登录界面
      next({ path: '/login' })
    } else {
      // 加载动态菜单和路由
      addDynamicMenuAndRoutes(userName, to, from);
      next();
    }
  }
})

/**
 * 加载动态菜单和路由
 */
function addDynamicMenuAndRoutes(userName, to, from) {
  // 处理IFrame嵌套页面
  handleIFrameUrl(to.path)
  if(store.state.app.menuRouteLoaded) {
    // console.log('动态菜单和路由已经存在.')
    return
  }
  var token=sessionStorage.getItem('token');


  let params={
    where: {
      "info.type":{"$in":[0,1]}
    }
  }
  let aaa = JSON.stringify(params);
  api.menu.findMenuTree()
    .then(res => {
      console.log(res.data)
      // 添加动态路由
      let dynamicRoutes = addDynamicRoutes(res.data)
      // 处理静态组件绑定路由
      handleStaticComponent(router, dynamicRoutes)
      router.addRoutes(router.options.routes)
      // console.log("路由",router);
      // 保存加载状态
      store.commit('menuRouteLoaded', true)
      // 保存菜单树
      store.commit('setNavTree', res.data)
    }).then(res => {
    api.user.findPermissions({'name':userName}).then(res => {
      // 保存用户权限标识集合
      store.commit('setPerms', res)
    })
  })
    .catch(function(res) {
    })
}

/**
 * 处理路由到本地直接指定页面组件的情况
 * 比如'代码生成'是要求直接绑定到'Generator'页面组件
 */
function handleStaticComponent(router, dynamicRoutes) {
  for(let j=0;j<dynamicRoutes.length; j++) {
    if(dynamicRoutes[j].name == '代码生成') {
      dynamicRoutes[j].component = Generator
      break
    }
  }
  router.options.routes[0].children = router.options.routes[0].children.concat(dynamicRoutes)
}

/**
 * 处理IFrame嵌套页面
 */
function handleIFrameUrl(path) {
  // 嵌套页面，保存iframeUrl到store，供IFrame组件读取展示
  let url = path
  let length = store.state.iframe.iframeUrls.length
  for(let i=0; i<length; i++) {
    let iframe = store.state.iframe.iframeUrls[i]
    if(path != null && path.endsWith(iframe.path)) {
      url = iframe.url
      store.commit('setIFrameUrl', url)
      break
    }
  }
}

/**
 * 添加动态(菜单)路由
 * @param {*} menuList 菜单列表
 * @param {*} routes 递归创建的动态(菜单)路由
 */
function addDynamicRoutes (menuList = [], routes = []) {

  var temp = []
  for (var i = 0; i < menuList.length; i++) {
    if (menuList[i].children && menuList[i].children.length >= 1) {
      temp = temp.concat(menuList[i].children)
    } else if (menuList[i].url && /\S/.test(menuList[i].url)) {
      menuList[i].url = menuList[i].url.replace(/^\//, '')
      // 创建路由配置
      var route = {
        path: menuList[i].url,
        component: null,
        name: menuList[i].name,
        meta: {
          icon: menuList[i].icon,
          index: menuList[i].id
        }
      }
      let path = getIFramePath(menuList[i].url)
      if (path) {
        // 如果是嵌套页面, 通过iframe展示
        route['path'] = path
        route['component'] = resolve => require([`@/views/IFrame/IFrame`], resolve)
        // 存储嵌套页面路由路径和访问URL
        let url = getIFrameUrl(menuList[i].url)
        let iFrameUrl = {'path':path, 'url':url}
        store.commit('addIFrameUrl', iFrameUrl)
      } else {
        try {
          // 根据菜单URL动态加载vue组件，这里要求vue组件须按照url路径存储
          // 如url="sys/user"，则组件路径应是"@/views/sys/user.vue",否则组件加载不到
          let array = menuList[i].url.split('/')
          let url = ''
          for(let i=0; i<array.length; i++) {
            url += array[i].substring(0,1).toUpperCase() + array[i].substring(1) + '/'
          }
          url = url.substring(0, url.length - 1)
          route['component'] = resolve => require([`@/views/${url}`], resolve)
        } catch (e) {}
      }
      routes.push(route)
    }
  }
  if (temp.length >= 1) {
    addDynamicRoutes(temp, routes)
  } else {
    console.log('动态路由加载...')
    //  console.log(routes)
    //  console.log('动态路由加载完成.')
  }
  return routes
}

// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//     // return originalPush.call(this, location).catch(err => err)
//     return originalPush.call(this, location)
// }


export default router



// WEBPACK FOOTER //
// ./src/router/index.js